import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showCategory?: boolean;
}

export default function ComicCard({ comic, showCategory = false }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return `${v}`;
  };

  const categoryLabel: Record<string, string> = {
    romance: '恋爱甜宠',
    fantasy: '奇幻冒险',
    action: '热血动作',
    mystery: '悬疑推理',
    comedy: '搞笑日常',
    harem: '后宫恋爱',
    drama: '剧情深度',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      {/* Cover */}
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium text-background-50 ${
            comic.status === '连载中' ? 'bg-primary-500' : 'bg-secondary-500'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-xs text-background-50">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              {comic.rating}
            </span>
            <span className="opacity-60">|</span>
            <span className="opacity-80">{formatViews(comic.views)} 阅读</span>
          </div>
        </div>
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        {showCategory && (
          <p className="text-xs text-primary-500 mt-1">
            {categoryLabel[comic.category] || comic.category}
          </p>
        )}
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
          更新至 {comic.chapters.length} 话
        </p>
      </div>
    </Link>
  );
}